import { useEffect, useState } from "react";

import { ONBOARDING_AGENT_TRIGGER_BOUNCE_DURATION_MS, ONBOARDING_AGENT_TRIGGER_BOUNCE_INTERVAL_MS } from "../constants";

/**
 * Periodically flashes the trigger's "bounce" animation to draw attention while it's idle.
 * Paused whenever the panel is open or another attention-grabbing UI (e.g. the nudge) is shown.
 */
export const useTriggerBounceAnimation = (isPaused: boolean): boolean => {
    const [isBouncing, setIsBouncing] = useState(false);

    useEffect(() => {
        if (isPaused) {
            setIsBouncing(false);
            return undefined;
        }

        const intervalId = window.setInterval(() => {
            setIsBouncing(true);
        }, ONBOARDING_AGENT_TRIGGER_BOUNCE_INTERVAL_MS);

        return () => window.clearInterval(intervalId);
    }, [isPaused]);

    useEffect(() => {
        if (!isBouncing) {
            return undefined;
        }

        const timeoutId = window.setTimeout(() => {
            setIsBouncing(false);
        }, ONBOARDING_AGENT_TRIGGER_BOUNCE_DURATION_MS);

        return () => window.clearTimeout(timeoutId);
    }, [isBouncing]);

    return isBouncing;
};
